import { assets } from "./assets/assets.queries";
import { commentThreadsData } from "./assets/commentThreads.queries";
import { configurations } from "./configurations/configurations.queries";
import { tenants } from "./configurations/tenants.queries";
import { entity } from "./entities/entities.queries";
import { project } from "./project/project.queries";
import { projectPermissions } from "./projects/permissions.queries";
import { projectInvitations } from "./projects/projectInvitations.queries";
import { registration } from "./registration/registration.queries";
import { user } from "./user/user.queries";

const queries = {
  assets,
  commentThreadsData,
  entity,
  user,
  projectPermissions,
  projectInvitations,
  registration,
  project,
  configurations,
  tenants,
};

export default queries;
